import anime from 'animejs/lib/anime.es'

import { defineComponent, ref } from '@vue/composition-api'
import Search from '../components/Search.vue'

export default defineComponent({
  name: 'AppHeader',
  components: {
    Search,
  },
  setup(){
    const prevItemIdOpen = ref(false);
    const itemIdOpen = ref(false);
    const loginMenuOpen = ref(false);

    const openMenu = (itemId) => {
      loginMenuOpen.value = false
      prevItemIdOpen.value = itemIdOpen.value
      itemIdOpen.value = itemId
    }

    const closeMenu = () => {
      itemIdOpen.value = false
    }

    // Animations
    const openMenuAnim  = (el, done) => {
      anime({
        targets: el,
        translateY: ['-50%', '0%'],
        opacity: ['0', '1'],
        duration: 150,
        delay: prevItemIdOpen.value === false ? 0 : 150,
        easing: 'linear',
        complete: () => {
          done()
        },
      })
    }

    const closeMenuAnim = (el, done) => {
      anime({
        targets: el,
        translateY: ['0%', '-50%'],
        opacity: ['1', '0'],
        duration: 150,
        delay: 0,
        easing: 'linear',
        complete: () => {
          done()
        },
      })
    }


    return {
      prevItemIdOpen,
      itemIdOpen,
      loginMenuOpen,

      openMenu,
      closeMenu,

      //Animations
      openMenuAnim,
      closeMenuAnim,
    }

  },
  // data() {
  //   return {
  //     prevItemIdOpen: false,
  //     itemIdOpen: false,
  //     loginMenuOpen: false,
  //   }
  // },
  // methods: {
  //   openMenu(itemId) {
  //     this.loginMenuOpen = false
  //     this.prevItemIdOpen = this.itemIdOpen
  //     this.itemIdOpen = itemId
  //   },
  //   closeMenu(){
  //     this.itemIdOpen = false
  //   },

  //   // Animations
  //   openMenuAnim (el, done) {
  //     anime({
  //       targets: el,
  //       translateY: ['-50%', '0%'],
  //       opacity: ['0', '1'],
  //       duration: 150,
  //       delay: this.prevItemIdOpen === false ? 0 : 150,
  //       easing: 'linear',
  //       complete: () => {
  //         done()
  //       },
  //     })
  //   },
  //   closeMenuAnim(el, done) {
  //     anime({
  //       targets: el,
  //       translateY: ['0%', '-50%'],
  //       opacity: ['1', '0'],
  //       duration: 150,
  //       delay: 0,
  //       easing: 'linear',
  //       complete: () => {
  //         done()
  //       },
  //     })
  //   },
  // },
})
